/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Composer from 'cio/components/action-composer/base';

@tagName('')
export default class AttributeUpdate extends Composer {
  previewObserverKeys = ['editableEntity.action.{attributeName,attributeValue}'];
  previewURL = 'previews/attribute';

  get shouldShowCreateOrUpdatePersonComposer() {
    return this.editableEntity.action.belongsTo('template').id() != null;
  }

  getPreviewData() {
    let { action } = this.editableEntity;
    return {
      name: action.attributeName,
      body: action.attributeValue,
    };
  }

  @readOnly('editableEntity.action.hasDirtyAttributes') isDirty;
  @readOnly('editableEntity.action.errorsMap.attributeName') isInvalid;

  @action
  rollback() {
    this.editableEntity.action.rollbackAttributes();

    this.onRollback();
  }
}
